const currentUserJson = localStorage.getItem("currentUser");
export const currentUser = currentUserJson ? JSON.parse(currentUserJson) : null;
